import ApolloClient from "apollo-client";
import config from "../temp/config";
import { InMemoryCache } from "apollo-cache-inmemory";
import { ApolloLink } from "apollo-link";
import { HttpLink } from "apollo-link-http";
import { withClientState } from "apollo-link-state";
const cache = new InMemoryCache({
  addTypename: false
});
const stateLink = withClientState({
  cache,
  resolvers: {
    Mutation: {
      updateNetworkStatus: (_, { isConnected }, { cache }) => {
        const data = {
          networkStatus: {
            __typename: "NetworkStatus",
            isConnected
          }
        };
        cache.writeData({ data });
        return null;
      }
    }
  }
  // defaults: {
  //   user: {
  //     __typename: "UserName",
  //     name: "name in local cache"
  //   }
  // }
});

const httpLink = new HttpLink({
  uri: config.graphQLEndpoint
});
const client = new ApolloClient({
  link: ApolloLink.from([stateLink, httpLink]),
  cache
});
export const gQuery = ({ query, variables }) => {
  return client.query({
    query: query,
    variables: variables
  });
};
